module.exports = __webpack_public_path__ + "static/media/duration.ae39700b.png";